<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" (click)="close.emit()">
  <div class="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
    <h2 class="modal-title mb-2">Cargar Factura</h2>
    <p class="text-sm text-gray-500 mb-4">
      Sube los archivos PDF y XML correspondientes a tu factura.
    </p>

    <!-- PDF -->
    <div class="border-2 border-dashed border-blue-400 rounded-lg p-6 text-center flex flex-col items-center mb-6">
      <span class="material-symbols-outlined text-5xl text-blue-400 mb-2">picture_as_pdf</span>
      <p class="text-gray-600 mb-1">Sube el documento PDF de la factura.</p>
      <p class="text-xs text-gray-400 mb-4">Solo se acepta formato PDF.</p>
      <input type="file" accept="application/pdf" (change)="onPdfSelected($event)" class="hidden" #pdfInput />
      <button class="px-4 py-2 upload-modal-button" (click)="pdfInput.click()">
        Seleccionar PDF
      </button>

      <p *ngIf="pdfName" class="mt-3 text-sm text-gray-700">
        Archivo seleccionado: <strong>{{ pdfName }}</strong>
      </p>
    </div>

    <!-- XML -->
    <div class="border-2 border-dashed border-blue-400 rounded-lg p-6 text-center flex flex-col items-center">
      <span class="material-symbols-outlined text-5xl text-blue-400 mb-2">description</span>
      <p class="text-gray-600 mb-1">Sube el archivo XML correspondiente.</p>
      <p class="text-xs text-gray-400 mb-4">Solo se acepta formato XML.</p>
      <input type="file" accept=".xml" (change)="onXmlSelected($event)" class="hidden" #xmlInput />
      <button class="px-4 py-2 upload-modal-button" (click)="xmlInput.click()">
        Seleccionar XML
      </button>

      <p *ngIf="xmlName" class="mt-3 text-sm text-gray-700">
        Archivo seleccionado: <strong>{{ xmlName }}</strong>
      </p>
    </div>

    <div class="flex justify-end mt-6 gap-3">
      <button class="px-4 py-2 cancel-modal-button" (click)="close.emit()">
        Cancelar
      </button> 
      <button class="px-4 py-2 upload-modal-button isabled:opacity-50" [disabled]="!pdfFile || !xmlFile" (click)="uploadFiles()">
        Subir archivos
      </button>
    </div>
  </div>
</div>
